window.addEventListener('load', () => {
  const tooltips: NodeListOf<HTMLElement> = document.querySelectorAll(
    '[data-tooltip="cursor"]',
  )

  if (tooltips.length > 0) {
    tooltips.forEach((tooltip) => {
      const section = tooltip.closest('[data-id]')

      if (!section) return

      section.addEventListener(
        'click',
        () => {
          if (!section.contains(tooltip)) return

          setTimeout(() => {
            tooltip.classList.add('hide')
          }, 500)
        },
        true,
      )

      section.addEventListener(
        'mousedown',
        () => {
          if (!section.contains(tooltip)) return

          setTimeout(() => {
            tooltip.classList.add('hide')
          }, 500)
        },
        true,
      )

      section.addEventListener(
        'touchstart',
        () => {
          if (!section.contains(tooltip)) return

          setTimeout(() => {
            tooltip.classList.add('hide')
          }, 500)
        },
        true,
      )

      section.addEventListener(
        'mouseover',
        () => {
          setTimeout(() => {
            tooltip.classList.add('hide')
          }, 3000)
        },
        true,
      )
    })
  }
})
